export const path = "/social-media-roundler";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "RRSS",
  section: "ROUNDLER",
  group: null,
  order: 4,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "master-rrss-roundler",
    "master-aluna-rrss",
    "roundler-admin",
    "aluna",
  ],
};
